const columns = [
    {
      name: 'Group ID',
      selector: (row) => row?.group_id,
      sortable: true,
      sortField: 'group_id',
    },
    {
      name: 'Congregation',
      selector: (row) => row?.group_name,
      sortable: true,
      sortField: 'group_name',
    },
    {
        name: 'WMRC Group',
        selector: (row) => row?.wmrc_group,
        sortable: true,
        sortField: 'wmrc_group',
      },
      {
        name: 'WMRC Name',
        selector: (row) => row?.wmrc_group_contact_name,
        sortable: true,
        sortField: 'wmrc_group_contact_name',
      },
      {
        name: 'Status',
        selector: (row) => row?.ref_status_cd,
        sortable: true,
        sortField: 'ref_status_cd',
      },
      {
        name: 'Year-Month',
        selector: (row) => row?.yearmonth,
        sortable: true,
        sortField: 'yearmonth',
      },
      {
        name: 'Incident Count',
        selector: (row) => row?.incident_count,
        sortable: true,
        sortField: 'incident_count',
      },
  ];
  
export { columns };
  

export const mobileColumns = [
  {
    name: 'Group ID',
    selector: (row) => row?.group_id,
    sortable: true,
    sortField: 'group_id',
  },
  {
    name: 'Group Name',
    selector: (row) => row?.group_name,
    sortable: true,
    sortField: 'group_name',
  },
  {
    name: 'WMRC Group',
    selector: (row) => row?.wmrc_group,
    sortable: true,
    sortField: 'wmrc_group',
  },
  {
    name: 'WMRC Name',
    selector: (row) => row?.wmrc_group_contact_name,
    sortable: true,
    sortField: 'wmrc_group_contact_name',
  },
  {
    name: 'Status',
    selector: (row) => row?.ref_status_cd,
    sortable: true,
    sortField: 'ref_status_cd',
  },
  {
    name: 'Year-Month',
    selector: (row) => row?.yearmonth,
    sortable: true,
    sortField: 'yearmonth',
  },
  {
    name: 'Incident Count',
    selector: (row) => row?.incident_count,
    sortable: true,
    sortField: 'incident_count',
  },
]
